export default {"src":"/_next/static/image/public/images/ic_bell_vertical_menu.f52c7abaef9312883b917396c5ae30e1.svg","height":20,"width":20};